import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {LoaderService} from '../loader-interceptor/loader-interceptor.service';
import {GlobalService} from '../../servicos/global.service';
import {Observable, Subscription} from 'rxjs';
import {InterceptorService} from '../../../interceptor-service';


declare const $: any;

@Component({
  selector: 'app-tab-page-top',
  templateUrl: './tab-page-top.component.html',
  styleUrls: ['./tab-page-top.component.scss']
})
export class TabPageTopComponent implements OnInit, HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  tema = this.globalService.tema;
  subsTema: Subscription;
  @Input() titulo: string;
  @Input() botaoRefresh = false;
  @Input() mediumTitle = false;
  @Input() botaoSomNotificacao = false;
  @Input() botaoNotificacao = false;
  @Input() botaoAtualizacaoAutomatica = false;
  @Input() botaoCrud = false;
  @Input() mostrarPesquisa = false;
  @Output() clickAtualizacaoAutomatica = new EventEmitter();
  @Output() clickSom = new EventEmitter();
  @Output() clickRefresh = new EventEmitter();
  @Output() clickPesquisa = new EventEmitter();
  showLoading = false;
  isMobile: boolean;

  constructor(private loaderService: LoaderService,
              private globalService: GlobalService,
              private interceptorService: InterceptorService) {

    this.loaderService.isLoading.subscribe(resposta => {
      this.showLoading = resposta;
    });
  }

  ngOnInit() {
    this.onResize();
    this.subsTema = this.globalService.temaSub.subscribe((tema) => {
      this.tema = tema;
    });
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    if (this.requests.length === 0) {
      this.loaderService.isLoading.next(false);
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requests.push(req);
    this.loaderService.isLoading.next(true);

    // We create a new observable which we return instead of the original
    return Observable.create(observer => {
      // And subscribe to the original observable to ensure the HttpRequest is made
      const subscription = next.handle(req)
        .subscribe(
          event => {
            if (event instanceof HttpResponse) {
              this.removeRequest(req);
              observer.next(event);
            }
          },
          err => {
            this.removeRequest(req);
            observer.error(err);
          },
          () => {
            this.removeRequest(req);
            observer.complete();
          });
      // return teardown logic in case of cancelled requests
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }

  onMouseOut(id: string) {
    $(id).tooltip('hide');
    $('[data-toggle="tooltip"]').tooltip();
  }

  emitirRefresh(id: string) {
    this.onMouseOut(id);
    this.clickRefresh.emit();
  }

  emitirPesquisa(id: string) {
    this.onMouseOut(id);
    this.clickPesquisa.emit();
  }

  emitirSomEvent(id: string) {
    this.onMouseOut(id);
    this.clickSom.emit();
  }

  emitirAutomatico(id: string) {
    this.onMouseOut(id);
    this.clickAtualizacaoAutomatica.emit();
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobile = this.globalService.isMobileExtra();
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }
}
